import { useMediaQuery } from '@lumapps/responsive/hooks/useMediaQuery';

export const usePrefersReducedMotion = () => useMediaQuery({ query: '(prefers-reduced-motion: reduce)' });
